import React from "react";
import { Avatar, Button, Layout, Menu, Space, Typography } from "antd";
import {
    DashboardOutlined,
    FileAddOutlined,
    FileTextOutlined,
    LogoutOutlined,
    UserOutlined,
} from "@ant-design/icons";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { clearAuth, getStoredUser } from "../../utils/authStorage";

const { Header, Content } = Layout;
const { Text } = Typography;

export default function AppLayout({ children }) {
    const location = useLocation();
    const navigate = useNavigate();
    const user = getStoredUser();

    const selectedKey =
        location.pathname.startsWith("/requests/new")
            ? "/requests/new"
            : location.pathname.startsWith("/requests")
                ? "/requests"
                : "/dashboard";

    const handleLogout = () => {
        clearAuth();
        navigate("/login", { replace: true });
    };

    const menuItems = [
        {
            key: "/dashboard",
            icon: <DashboardOutlined />,
            label: <Link to="/dashboard">Dashboard</Link>,
        },
        {
            key: "/requests/new",
            icon: <FileAddOutlined />,
            label: <Link to="/requests/new">New Request</Link>,
        },
        {
            key: "/requests",
            icon: <FileTextOutlined />,
            label: <Link to="/requests">My Requests</Link>,
        },
    ];

    return (
        <Layout style={{ minHeight: "100vh", background: "#f5f7fb" }}>
            <Header
                style={{
                    position: "fixed",
                    top: 0,
                    left: 0,
                    right: 0,
                    zIndex: 1000,
                    background: "#001529",
                    padding: "0 20px",
                    height: 64,
                    display: "flex",
                    alignItems: "center",
                    gap: 20,
                    boxShadow: "0 2px 8px rgba(0,0,0,0.08)",
                }}
            >
                <Link
                    to="/dashboard"
                    style={{
                        display: "flex",
                        alignItems: "center",
                        gap: 12,
                        minWidth: "fit-content",
                        textDecoration: "none",
                    }}
                >
                    <Avatar
                        size={36}
                        style={{
                            background: "rgba(255,255,255,0.16)",
                            color: "#fff",
                            fontWeight: 700,
                            flexShrink: 0,
                        }}
                    >
                        CP
                    </Avatar>

                    <div style={{ lineHeight: 1.1 }}>
                        <div
                            style={{
                                color: "#fff",
                                fontSize: 20,
                                fontWeight: 700,
                                whiteSpace: "nowrap",
                            }}
                        >
                            Customer Portal
                        </div>
                        <div
                            style={{
                                color: "rgba(255,255,255,0.7)",
                                fontSize: 12,
                                whiteSpace: "nowrap",
                            }}
                        >
                            Transaction requests
                        </div>
                    </div>
                </Link>

                <div
                    style={{
                        flex: 1,
                        minWidth: 0,
                        display: "flex",
                        alignItems: "center",
                        overflow: "hidden",
                    }}
                >
                    <Menu
                        theme="dark"
                        mode="horizontal"
                        selectedKeys={[selectedKey]}
                        items={menuItems}
                        style={{
                            flex: 1,
                            minWidth: 0,
                            background: "transparent",
                            borderBottom: "none",
                        }}
                        overflowedIndicator={null}
                    />
                </div>

                <Space size={12} style={{ minWidth: "fit-content", flexShrink: 0 }}>
                    <Space size={8}>
                        <Avatar
                            size={30}
                            icon={<UserOutlined />}
                            style={{ background: "rgba(255,255,255,0.16)" }}
                        />
                        <Text
                            style={{
                                color: "#fff",
                                maxWidth: 180,
                                whiteSpace: "nowrap",
                                overflow: "hidden",
                                textOverflow: "ellipsis",
                                marginBottom: 0,
                            }}
                        >
                            {user?.username || "Customer"}
                        </Text>
                    </Space>

                    <Button icon={<LogoutOutlined />} onClick={handleLogout}>
                        Logout
                    </Button>
                </Space>
            </Header>

            <Content
                style={{
                    padding: 24,
                    marginTop: 64,
                    background: "#f5f7fb",
                }}
            >
                {children}
            </Content>
        </Layout>
    );
}